const formatInstitutionToState = ({ general, features }) => {
  const endpoints = {
    api: `https://api.${general.base_domain}`,
  };

  return {
    general,
    name: general.display_name,
    keys: {
      endpoints,
    },
    features,
  };
};

export default formatInstitutionToState;
